import StarterKit from '@tiptap/starter-kit';
import TextAlign from '@tiptap/extension-text-align';
import { FontSize, TextStyle } from '@tiptap/extension-text-style';
import Color from '@tiptap/extension-color';
import Highlight from '@tiptap/extension-highlight';

/**
 * Zelfde rich-text subset als gebruikelijk in TipTap-tabellen voor omschrijvingscellen:
 * gebruikt voor generateHTML/generateJSON op alleen cel-inhoud (geen nesting van table).
 * StarterKit bevat al o.a. Bold, Italic, Underline, Strike, bullet/ordered lists.
 */
export const investmentCellRichExtensions = [
  StarterKit.configure({
    heading: false,
    codeBlock: false,
    horizontalRule: false,
    blockquote: false,
  }),
  TextStyle,
  Color,
  FontSize,
  Highlight.configure({ multicolor: true }),
  TextAlign.configure({ types: ['paragraph'] }),
];
